<template>
    <div id="skala-form">
        <v-card text>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-2"
                    >
                        Nama Skala
                    </v-list-item-title>
                    <v-text-field
                        placeholder="Nama Skala"
                        v-model="data.scale_name"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-2"
                    >
                        Jenjang
                    </v-list-item-title>

                    <div class="d-inline mb-5 d-flex" style="gap: 10px">
                        <v-checkbox
                            label="SD"
                            value="SD"
                            v-model="data.scale_level"
                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                            outlined
                        />

                        <v-checkbox
                            label="SMP"
                            value="SMP"
                            v-model="data.scale_level"
                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                            outlined
                        />

                        <v-checkbox
                            label="SMA"
                            value="SMA"
                            v-model="data.scale_level"
                            class="pa-2 ma-0 d-inline-flex checkbox-selection"
                            outlined
                        />
                    </div>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-2"
                    >
                        Jenis
                    </v-list-item-title>

                    <div class="d-inline mb-5 d-flex" style="gap: 10px">
                        <v-radio-group
                            row
                            v-model="data.scale_type"
                            style="margin-top: -10px"
                        >
                            <v-radio
                                label="Free"
                                value="FREE"
                                class="radio-selection"
                                active-class="act-radio-btn"
                            ></v-radio>

                            <v-radio
                                label="Premium"
                                value="PREMIUM"
                                class="radio-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                        </v-radio-group>
                    </div>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-2"
                    >
                        Deskripsi
                    </v-list-item-title>
                    <v-textarea
                        placeholder="Deskripsi Skala"
                        v-model="data.scale_description"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>

            <v-list-item
                v-if="theme_type !== 'tryout'"
                two-line
                class="pa-0 mb-2"
            >
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-3"
                    >
                        Jenis Respon
                    </v-list-item-title>

                    <v-radio-group
                        row
                        v-model="data.type"
                        style="margin-top: -10px"
                    >
                        <v-radio
                            label="Likert"
                            value="likert"
                            class="radio-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                        <v-radio
                            label="Multiple Choice"
                            value="choice"
                            class="radio-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                        <v-radio
                            label="Yes or No"
                            value="yesno"
                            class="radio-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
                v-if="data.type === 'likert' && theme_type !== 'tryout'"
                two-line
                class="pa-0 mb-2"
            >
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-3"
                    >
                        Jumlah Respon
                    </v-list-item-title>

                    <v-radio-group
                        row
                        v-model="data.max_answer"
                        style="margin-top: -10px"
                    >
                        <v-radio
                            label="4"
                            :value="4"
                            class="radio-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                        <v-radio
                            label="5"
                            :value="5"
                            class="radio-selection"
                            active-class="act-radio-btn"
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
                v-if="data.type === 'choice' && theme_type !== 'tryout'"
                two-line
                class="pa-0 mb-2"
            >
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-3"
                    >
                        Jumlah Respon
                    </v-list-item-title>

                    <v-select
                        v-model="jumlah_value"
                        outlined
                        :items="[3, 4, 5, 6, 7, 8, 9, 10]"
                        @change="form_value_answer = []"
                    ></v-select>
                </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="data.type === 'choice'" two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-2"
                    >
                        Value
                    </v-list-item-title>

                    <div class="mt-3 px-1 mb-5">
                        <v-row>
                            <v-col
                                v-for="(val, i) in jumlah_value"
                                cols="1"
                                :key="i"
                            >
                                <v-text-field
                                    maxlength="1"
                                    outlined
                                    class="font-weight-bold text-center"
                                    v-model="form_value_answer[i]"
                                />
                            </v-col>
                        </v-row>
                    </div>
                </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item v-if="data.type === 'choice'" two-line class="pa-0">
        <v-list-item-content class="pa-0">
          <v-list-item-title class="font-weight-500 darkgrey--text pb-2">
            Value
          </v-list-item-title>

          <div class="mt-3 px-1 mb-5">
            <v-row>
              <v-col cols="1">
                <v-text-field
                  maxlength="1"
                  outlined
                  v-model="form_value_answer.value1"
                />
              </v-col>

              <v-col cols="1">
                <v-text-field
                  maxlength="1"
                  outlined
                  v-model="form_value_answer.value2"
                />
              </v-col>

              <v-col cols="1">
                <v-text-field
                  maxlength="1"
                  outlined
                  v-model="form_value_answer.value3"
                />
              </v-col>

              <v-col cols="1">
                <v-text-field
                  maxlength="1"
                  outlined
                  v-model="form_value_answer.value4"
                />
              </v-col>

              <v-col cols="1">
                <v-text-field
                  maxlength="1"
                  outlined
                  v-model="form_value_answer.value5"
                />
              </v-col>

              <v-col cols="1">
                <v-text-field
                  maxlength="1"
                  outlined
                  v-model="form_value_answer.value6"
                />
              </v-col>
            </v-row>
          </div>
        </v-list-item-content>
      </v-list-item> -->

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-2"
                    >
                        Durasi Pengerjaan Skala
                    </v-list-item-title>
                    <v-text-field
                        v-model="data.processing_time"
                        type="text"
                        placeholder="Durasi (dalam menit)"
                        suffix="menit"
                        outlined
                        maxlength="3"
                        @keypress="handleInputNumber($event)"
                    />
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-2"
                    >
                        Judul Intro
                    </v-list-item-title>
                    <v-text-field
                        placeholder="Judul Intro"
                        v-model="data.intro_name"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title
                        class="font-weight-500 darkgrey--text pb-2"
                    >
                        Deskripsi Intro
                    </v-list-item-title>

                    <app-editor
                        v-on:content-updated="data.intro_description = $event"
                        :value="data.intro_description"
                        :hasUpload="false"
                        title="Deskripsi Intro"
                    ></app-editor>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold">
                        User Group
                    </v-list-item-title>
                    <v-autocomplete
                        :items="user_groups"
                        item-text="user_group_name"
                        item-value="id"
                        placeholder="-- Pilih user group --"
                        outlined
                        chips
                        multiple
                        v-model="data.user_group"
                    >
                    </v-autocomplete>
                </v-list-item-content>
            </v-list-item>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="backToScale()" depressed text> Kembali </v-btn>

                <v-btn
                    id="tryout_simpan"
                    color="blew"
                    :loading="isLoading"
                    @click="submit()"
                    depressed
                    dark
                >
                    Selanjutnya
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import MarkdownEditor from "@/modules/global/components/plugins/MarkdownEditor-c";
import ambis_test from "../services/ambis_test";
import axios from "axios";

export default {
    name: "skala-form",

    components: {
        "app-spinner": Spinner,
        "app-editor": MarkdownEditor,
    },

    data: function () {
        return {
            isLoading: false,
            errors: [],
            data: {
                theme_id: null,
                scale_name: null,
                scale_level: [],
                scale_description: null,
                processing_time: null,
                norm: null,
                status: "draft",
                type: "yesno",
                scale_type: "FREE",
                max_answer: 0,
                set_value_answer: "",
                scale_picture: null,
                intro_name: null,
                intro_description: null,
                user_group: [],
            },
            form: {
                user_group: [],
            },
            list_value_answer: [],
            // form_value_answer: {
            //   value1: "R",
            //   value2: "I",
            //   value3: "A",
            //   value4: "S",
            //   value5: "E",
            //   value6: "C",
            // },
            form_value_answer: [],
            jumlah_value: 3,
            user_groups: [],
            theme: {},
            theme_type: null,
        };
    },

    computed: {
        // value_answer_combine() {
        //   let resultString = "";
        //   let form_value_answer = this.form_value_answer;
        //   for (let key in form_value_answer) {
        //     if (form_value_answer.hasOwnProperty(key)) {
        //       resultString += form_value_answer[key] + ";";
        //     }
        //   }
        //   resultString =
        //     this.data.type === "choice" ? resultString.slice(0, -1) : "";
        //   return resultString;
        // },

        value_answer_combine() {
            let resultString = "";
            let form_value_answer = this.form_value_answer;

            for (let key in form_value_answer) {
                resultString += form_value_answer[key] + ";";
            }

            resultString =
                this.data.type === "choice" ? resultString.slice(0, -1) : "";

            return resultString;
        },
    },

    watch: {
        // "data.type": function (val) {},
        // value_answer_combine(val) {
        //   alert(val);
        // },
    },

    methods: {
        submit: function () {
            var context = this;
            const scale_id =
                context.$route.query.scale_id || context.$attrs.data.id;
            context.data.theme_id = context.$route.query.theme_id;
            context.data.set_value_answer = context.value_answer_combine;

            if (context.data.type === "choice") {
                context.data.max_answer = context.jumlah_value;
            }

            if (this.validateForm()) {
                context.isLoading = true;

                if (!scale_id) {
                    ambis_test.addScale(context.data, function (result) {
                        if (result.success) {
                            // context.$store.commit("showAlert", {
                            //     message: `Berhasil Menyimpan Data!`,
                            //     type: "success",
                            // });

                            context.scale_id = "";
                            context.$emit("completed", result.data);
                        } else {
                            context.$store.commit("showAlert", {
                                message: `Gagal Menyimpan Data!`,
                                type: "error",
                            });
                        }

                        context.isLoading = false;
                    });
                } else {
                    ambis_test.editScale(
                        scale_id,
                        context.data,
                        function (result) {
                            if (result.success) {
                                // context.$store.commit("showAlert", {
                                //     message: `Berhasil Menyimpan Data!`,
                                //     type: "success",
                                // });

                                context.$emit("completed", result.data);
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal Menyimpan Data!`,
                                    type: "error",
                                });
                            }
                            context.isLoading = false;
                        }
                    );
                }
            }
        },

        getDetailScale() {
            var context = this;
            const scale_id =
                context.$route.query.scale_id || context.$attrs.data.id;

            ambis_test.getDetailScale(scale_id, function (result) {
                if (result.success) {
                    const data = result.data;
                    let scale_level = data.scale_level || "";
                    let scale_level_arr = scale_level.split(",");

                    context.data = {
                        theme_id: context.$route.query.theme_id,
                        scale_name: data.scale_name,
                        scale_level: scale_level_arr,
                        scale_description: data.scale_description,
                        processing_time: data.processing_time,
                        norm: "",
                        status: data.status,
                        type: data.question_type,
                        scale_type: data.scale_type,
                        max_answer: data.max_answer,
                        set_value_answer: data.value_answer,
                        scale_picture: null,
                        intro_name: data.intro_name,
                        intro_description: data.intro_description,
                    };

                    const value_answer = data.value_answer.split(";");
                    for (let key in value_answer) {
                        context.form_value_answer[key] = value_answer[key];
                    }

                    if (data.question_type === "choice") {
                        context.jumlah_value =
                            data.max_answer || context.form_value_answer.length;
                    }

                    context.data.user_group = data.user_group.map(
                        (group) => group.id
                    );

                    // var userGroup = [];
                    // if (data.user_group.length > 0) {
                    //   for (var i = 0; i < context.form.user_group.length; i++) {
                    //     userGroup.push(context.form.user_group[i]);
                    //   }
                    // }

                    // context.form_value_answer = {
                    //   value1: value_answer[0],
                    //   value2: value_answer[1],
                    //   value3: value_answer[2],
                    //   value4: value_answer[3],
                    //   value5: value_answer[4],
                    //   value6: value_answer[5],
                    // };
                }
            });
        },

        validateForm: function () {
            var err = false;
            if (!this.data.scale_name) {
                this.$store.commit("showAlert", {
                    message: `Nama Skala wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (this.data.scale_level.length === 0) {
                this.$store.commit("showAlert", {
                    message: `Jenjang wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.scale_description) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.type && this.theme_type !== "tryout") {
                this.$store.commit("showAlert", {
                    message: `Jenis Respon wajib diisi!`,
                    type: "error",
                });
                err = true;
            } else if (!this.data.processing_time) {
                this.$store.commit("showAlert", {
                    message: `Durasi Pengerjaan wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.data.set_value_answer && this.data.type === "choice") {
                this.$store.commit("showAlert", {
                    message: `Value choice wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (this.data.max_answer === 0 && this.data.type === "likert") {
                this.$store.commit("showAlert", {
                    message: `Jumlah Respon wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            // Check duplication value answer (if choice question type)
            if (this.data.type === "choice") {
                let obj = this.form_value_answer;
                let checkedValues = [];

                // for (let key in obj) {
                //   if (obj.hasOwnProperty(key)) {
                //     let value = obj[key];
                //     if (checkedValues.includes(value)) {
                //       this.$store.commit("showAlert", {
                //         message: `Value choice tidak boleh sama!`,
                //         type: "error",
                //       });
                //       err = true;
                //     } else if (!value || value === "") {
                //       this.$store.commit("showAlert", {
                //         message: `Value choice tidak boleh ada yang kosong!`,
                //         type: "error",
                //       });
                //       err = true;
                //     } else {
                //       checkedValues.push(value);
                //     }
                //   }
                // }

                for (let i = 0; i < obj.length; i++) {
                    let value = obj[i];

                    if (checkedValues.includes(value)) {
                        this.$store.commit("showAlert", {
                            message: `Value choice tidak boleh sama!`,
                            type: "error",
                        });
                        err = true;
                    } else if (!value || value === "") {
                        this.$store.commit("showAlert", {
                            message: `Value choice tidak boleh ada yang kosong!`,
                            type: "error",
                        });
                        err = true;
                    } else {
                        checkedValues.push(value);
                    }
                }
            }

            return !err;
        },

        handleInputNumber(event) {
            if (!/\d/.test(event.key)) return event.preventDefault();
        },

        getUserGroupData() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "/payment/list/user_group?page=1&per_page=1000";

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.user_groups = response.data.user_groups;
                }
            });
        },

        getUniqueListBy(arr) {
            return arr.filter(
                (value, index, array) => array.indexOf(value) === index
            );
        },

        backToScale() {
            this.$router.replace({
                path: "/detail-skala",
                query: {
                    id: this.$route.query.theme_id,
                },
            });
        },

        getDetailTheme() {
            var context = this;
            const theme_id = context.$route.query.theme_id;

            ambis_test.getDetailTheme(theme_id, function (result) {
                if (result.success) {
                    context.theme = result.data;
                    context.theme_type = result.data.type;
                    // alert(context.theme_type)
                }
            });
        },
    },

    mounted: function () {
        if (this.$route.query.scale_id || this.$attrs.data.id) {
            this.getDetailScale();
        }

        if (this.$route.query.theme_id) {
            this.getDetailTheme();
        }

        this.getUserGroupData();
    },
};
</script>

<style scoped>
.radio-selection {
    background: #fbfbfb;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 100px;
}

.checkbox-selection {
    background: #fbfbfb;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 5px !important;
    height: 45px !important;
}
</style>



// WEBPACK FOOTER //
// SkalaForm.vue?15cf8766